import BlainBaseService from "./BlainBaseService";
import { CreateOauthAccountRequest, ICreateAccountResource } from "JS/types/Account";
import { IConfirmCodeRequest, ILinkAccountLookupInfo, ILinkRewardsUser, ILinkRewardsUserResponse, ISendCodeResponse } from "JS/types/rewards";

export interface IRewardsService {
	linkUserWithRewardsNum(accountInfo: ILinkRewardsUser, createAccountRequest: ICreateAccountResource, createOauthAccountRequest: CreateOauthAccountRequest, antiForgeryToken: string): Promise<ILinkRewardsUserResponse>;
	joinRewards(phoneNumber: string): Promise<ILinkRewardsUserResponse>;
	confirmUserCode(request: IConfirmCodeRequest, antiForgeryToken: string): Promise<ILinkRewardsUserResponse>;
	findRewardsToLink(lookupObject: ILinkAccountLookupInfo): Promise<ILinkRewardsUserResponse>;
	sendVerificationCode(linkUserObject: ILinkRewardsUser): Promise<ISendCodeResponse>;
}

export default class RewardsService extends BlainBaseService implements IRewardsService {

	async linkUserWithRewardsNum(accountInfo: ILinkRewardsUser, createAccountRequest: ICreateAccountResource, createOauthAccountRequest: CreateOauthAccountRequest, antiForgeryToken: string): Promise<ILinkRewardsUserResponse> {
		return await this._httpSvc.post<ILinkRewardsUserResponse>("/account/linkuserwithrewardsnum", { accountInfo, createAccountRequest, createOauthAccountRequest }, { headers: { 'blainVerificationToken': antiForgeryToken } });
	}

	async joinRewards(phoneNumber: string): Promise<ILinkRewardsUserResponse> {
		return await this._httpSvc.post<ILinkRewardsUserResponse>("/account/newrewardsaccount", { phoneNumber });
	}

	async confirmUserCode(request: IConfirmCodeRequest, antiForgeryToken: string): Promise<ILinkRewardsUserResponse> {
		return await this._httpSvc.post<ILinkRewardsUserResponse>("/account/confirmlinkaccount", request, { headers: { 'blainVerificationToken': antiForgeryToken } });
	}

	async findRewardsToLink(lookupObject: ILinkAccountLookupInfo): Promise<ILinkRewardsUserResponse> {
		return await this._httpSvc.post<ILinkRewardsUserResponse>("/account/findrewardstolink", lookupObject);
	}

	async sendVerificationCode(linkUserObject: ILinkRewardsUser): Promise<ISendCodeResponse> {
		return await this._httpSvc.post<ILinkRewardsUserResponse>("/account/sendverificationcode", linkUserObject);
	}
}